/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export class AbstractNode {
}
//# sourceMappingURL=types.js.map